import React, { useState } from "react";

export default function ContactForm() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  return (
    <div className="contactForm">
      <form action="https://formsubmit.co/holaszyd1@gmail.com" method="POST">
        <div className="div form-group">
          <label htmlFor="name">
            Your Name
            <input
              type="text"
              id="name"
              name="name"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
              required
            />
          </label>
        </div>
        <div className="div form-group">
          <label htmlFor="email">
            Your Email
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              required
            />
          </label>
        </div>
        <div className="div form-group">
          <label htmlFor="message">
            Message
            <textarea
              type="message"
              name="message"
              id="message"
              value={message}
              onChange={(e) => {
                setMessage(e.target.value);
              }}
              required
            />
          </label>
        </div>
        <input
          type="hidden"
          name="_next"
          value="https://portfolio3-ajibade123.vercel.app/"
        />
        <button type="submit">Send</button>
      </form>
    </div>
  );
}
